import React, { useEffect, useState } from 'react';
import NoDataFound from '../../NoDataFound/NoDataFound'
import {
  Chart as ChartJS,
  RadialLinearScale,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';
import {Doughnut } from 'react-chartjs-2';
import useThemeTextColor from '../../../../../utils/useThemeTextColor';

ChartJS.register(RadialLinearScale, ArcElement, Tooltip, Legend);

const WeeklySalesDistribution = ({ chartData }) => {
  const textColor = useThemeTextColor();
  const borderColor = useThemeTextColor('--why-choose-card-border');
  const bgColor = useThemeTextColor('--white-color')
  
  if (!Array.isArray(chartData) || chartData.length === 0) {
    return <NoDataFound height={300} />;
  }

  const [transformedData, setTransformedData] = useState(null);

  useEffect(() => {
    if (Array.isArray(chartData) && chartData.length > 0) {
      const weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      const sorted = [...chartData].sort((a, b) => a.weekday - b.weekday);

      const labels = sorted.map(item => weekDays[item.weekday % 7]);
      const values = sorted.map(item => parseFloat(item.percentage));

      const backgroundColor = [
        '#a076f9', '#fcd34d', '#fb7185', '#4ade80',
        '#38bdf8', '#f43f5e', '#f97316'
      ];

      setTransformedData({
        labels,
        datasets: [
          {
            label: 'Sales',
            data: values,
            backgroundColor: backgroundColor.slice(0, values.length),
            borderWidth: 1,
            // hoverOffset: 20
          }
        ]
      });
    } else {
      setTransformedData(null);
    }
  }, [chartData]);

    const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '50%', // makes it a donut
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          usePointStyle: true,
          pointStyle: 'circle',
          padding: 10,
          boxWidth: 10,
          color: textColor
        }
      },
      tooltip: {
        callbacks: {
          label: ctx => `${ctx.label}: ${ctx.raw}%`
        }
      },
        datalabels: {
        color: '#fff',
        font: {
          weight: 'bold',
          size: 12
        },
        anchor: 'end',
        align: 'start',
        offset: 10,
        clamp: true,
        formatter: (value) => `${value.toFixed(1)}%`
      }
    }
  };


  if (!transformedData) {
    return (
      <div
        style={{ height: 250 }}
        className="d-flex justify-content-center align-items-center"
      >
        <p className="no-data-found">No data found for the given criteria.</p>
      </div>
    );
  }

  return (
    <div
      style={{
        width: '100%',
        minWidth: '250px',
        maxWidth: '100%',
        height: '350px',
        padding: '0 10px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <div style={{ width: '100%', height: '100%' }}>
        <Doughnut data={transformedData} options={options} />
      </div>
    </div>
  );
};

export default WeeklySalesDistribution;
